export const TREND_DATA_URL = "/dummy/trendData.json";

export const ADS_DATA_URL = "/dummy/adsData.json";
